import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import HomeIcon from "./../../assets/images/games-icon/home-icon.png";
import CasinoIcon from "./../../assets/images/games-icon/casino-icon.png";
import InplayIcon from "./../../assets/images/games-icon/inplay-icon.png";
import CricketIcon from "./../../assets/images/games-icon/cricket-icon.png";
import SoccerIcon from "./../../assets/images/games-icon/soccer-icon.png";
import TennisIcon from "./../../assets/images/games-icon/tennis-icon.png";
import GolfIcon from "./../../assets/images/games-icon/golf-icon.png";
import RugbyIcon from "./../../assets/images/games-icon/rugby-icon.png";
import BoxingIcon from "./../../assets/images/games-icon/boxing-icon.png";
import horseracingIcon from "./../../assets/images/games-icon/horseracing-icon.png";
import EsportsIcon from "./../../assets/images/games-icon/esports-icon.png";
import VolleyballIcon from "./../../assets/images/games-icon/volleyball-icon.png";
import CyclingIcon from "./../../assets/images/games-icon/cycling-icon.png";
import SnookerIcon from "./../../assets/images/games-icon/snooker-icon.png";
import BaseballIcon from "./../../assets/images/games-icon/baseball-icon.png";
import NetballIcon from "./../../assets/images/games-icon/netball-icon.png";
import BasketballIcon from "./../../assets/images/games-icon/basketball-icon.png";
import IceHockeyIcon from "./../../assets/images/games-icon/icehockey-icon.png";
import HandballIcon from "./../../assets/images/games-icon/handball-icon.png";
import DartsIcon from "./../../assets/images/games-icon/darts-icon.png";
import GreyhoundIcon from "./../../assets/images/games-icon/greyhoundracing-icon.png";
import PoliticsIcon from "./../../assets/images/games-icon/politics-icon.png";
import SearchIcon from "../../assets/svg/SearchIcon";

import EzugiIcon from "./../../assets/images/icons/Ezugi.png";
import EvolutionIcon from "./../../assets/images/icons/evo.png";

const LeftBarSports = () => {
  const navigate = useNavigate();
  const { sportsData, oddsData, showBetSlip } = useSelector(
    (state) => state.sports
  );

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`
    );
  };

  const tabs = [
    {
      id: 1,
      eventKey: "1",
      name: "In play",
    },
    {
      id: 2,
      eventKey: "2",
      name: "Cricket",
    },
    {
      id: 3,
      eventKey: "3",
      name: "Soccer",
    },
    {
      id: 4,
      eventKey: "4",
      name: "Tennis",
    },
  ];

  return (
    <>
      <div className="leftbarSec">
        <div className="SearchBar">
          <SearchIcon />
          <input type="text" placeholder="Search" />
        </div>

        <div className="GamesLeftBar">
          <ul>
            <li>
              <a href="/sports">
                <img src={SoccerIcon} />
                <span>Sports</span>
              </a>
            </li>
            <li>
              <a href="/sports">
                <img src={InplayIcon} />
                <span>Inplay</span>
              </a>
            </li>
            <li>
              <a href="/Casino">
                <img src={CasinoIcon} />
                <span>Games</span>
              </a>
            </li>
            <li>
              <a href="/casino/ezugi">
                <img src={EzugiIcon} />
                <span>Ezugi</span>
              </a>
            </li>
            <li>
              <a href="/casino/evolution">
                <img src={EvolutionIcon} />
                <span>Evolution</span>
              </a>
            </li>
          </ul>
        </div>
        <ul>
          <li className="games_link">
            {/* <h6>Quick Links</h6> */}
            <ul>
              <li>
                <div
                  onClick={() => {
                    navigate("/home");
                  }}
                >
                  <img src={HomeIcon} alt="Home Icon" />
                  <span>Home</span>
                </div>
              </li>
            </ul>
          </li>

          <li className="games_link">
            {/* <h6>Sports</h6> */}
            <ul>
              <li>
                <div
                  onClick={() => {
                    navigate("/sports", { state: { selectedTab: "2" } });
                  }}
                >
                  <img src={CricketIcon} alt="Cricket Icon" />
                  <span>Cricket</span>
                  <div class="sport-event-count badge">
                    {sportsData?.[0]?.values.length}
                  </div>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/sports", { state: { selectedTab: "3" } });
                  }}
                >
                  <img src={SoccerIcon} alt="Soccer Icon" />
                  <span>Soccer</span>
                  <div class="sport-event-count badge">
                    {" "}
                    {sportsData?.[1]?.values.length}
                  </div>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/sports", { state: { selectedTab: "4" } });
                  }}
                >
                  <img src={TennisIcon} alt=" Icon" />
                  <span>Tennis</span>
                  <div class="sport-event-count badge">
                    {" "}
                    {sportsData?.[2]?.values.length}
                  </div>
                </div>
              </li>
              <li>
                <a href="/sports">
                  <img src={GolfIcon} alt="Golf Icon" />
                  <span>Golf</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={RugbyIcon} alt="Rugby Icon" />
                  <span>Rugby</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={BoxingIcon} alt="Boxing Icon" />
                  <span>Boxing</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={horseracingIcon} alt="horseracing Icon" />
                  <span>horseracing</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={EsportsIcon} alt="Esports Icon" />
                  <span>Esports</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={VolleyballIcon} alt="Volleyball Icon" />
                  <span>Volleyball</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={CyclingIcon} alt="Cycling Icon" />
                  <span>Cycling</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={SnookerIcon} alt="Snooker Icon" />
                  <span>Snooker</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={BaseballIcon} alt="Baseball Icon" />
                  <span>Baseball</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={NetballIcon} alt="Netball Icon" />
                  <span>Netball</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={BasketballIcon} alt="Basketball Icon" />
                  <span>Basketball</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={IceHockeyIcon} alt="Ice Hockey Icon" />
                  <span>Ice Hockey</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={HandballIcon} alt="Handball Icon" />
                  <span>Handball</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={DartsIcon} alt="Darts Icon" />
                  <span>Darts</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={GreyhoundIcon} alt="Greyhound Racing Icon" />
                  <span>Greyhound Racing</span>
                </a>
              </li>
              <li>
                <a href="/sports">
                  <img src={PoliticsIcon} alt="Politics Icon" />
                  <span>Politics</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default LeftBarSports;
